const docPhTxt = document.querySelector(".doctor-phy-reveal");
const docReveal = document.querySelector("#doctors-phy");

docReveal.addEventListener("mouseleave", () => {
  docPhTxt.classList.remove("active");
});
docReveal.addEventListener("mouseover", () => {
  docPhTxt.classList.add("active");
});

const docGpTxt = document.querySelector(".doctor-gp-reveal");
const docAltReveal = document.querySelector("#doctors-gp");

docAltReveal.addEventListener("mouseleave", () => {
  docGpTxt.classList.remove("active");
});
docAltReveal.addEventListener("mouseover", () => {
  docGpTxt.classList.add("active");
});

const MedTxt = document.querySelector(".medical-schemes-reveal");
const MedReveal = document.querySelector("#medical-sch");

MedReveal.addEventListener("mouseleave", () => {
  MedTxt.classList.remove("active");
});
MedReveal.addEventListener("mouseover", () => {
  MedTxt.classList.add("active");
});

const PatTxt = document.querySelector(".patients-reveal");
const PatientsReveal = document.querySelector("#patients");

PatientsReveal.addEventListener("mouseleave", () => {
  PatTxt.classList.remove("active");
});
PatientsReveal.addEventListener("mouseover", () => {
  PatTxt.classList.add("active");
});
const HospTxt = document.querySelector(".hospital-groups-reveal");
const HospReveal = document.querySelector("#hosp-gr");

HospReveal.addEventListener("mouseleave", () => {
  HospTxt.classList.remove("active");
});
HospReveal.addEventListener("mouseover", () => {
  HospTxt.classList.add("active");
});
